// extracted by mini-css-extract-plugin
export default {"arrow":"style_arrow__qVYOV","formGroup":"style_formGroup__iJtwM","actions":"style_actions__JZXID"};